function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.54 19.673c5.263 0 7.349 2.318 12.782 2.318 5.432 0 6.467-1.453 11.766-1.453M.54 24.973h24.547M.54 14.592c5.262 0 7.543 3.893 12.976 3.893 5.433 0 6.056-1.514 11.57-1.514",
  stroke: "currentColor",
  strokeWidth: "1.081",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.964 12.12a.564.564 0 01-.332.725c-2.314.86-4.082.97-4.747.898a.564.564 0 01-.468-.364 10.25 10.25 0 01-.212-.636l-7.752 1.307a3.572 3.572 0 01-3.24-1.124l-.406-.456-3.427.911c-1.436.102-2.207-.352-3.134-1.315-.343-.356-.47-1.036-.044-1.422l7.544-3.189c2.043-.927 4.485-1.08 5.862-1.127l4.151-.211c.04-.338.084-.633.128-.871a.564.564 0 01.358-.425l2.115-.786a.564.564 0 01.725.333zm-15.915.049l-.189-.209.46-.247c.433-.216.949-.467 1.515-.54l3.956-.513a.564.564 0 10-.144-1.119l-3.957.513c-.766.1-2.195.649-2.883 1.01L9.35 12.22c-1.208-.013-1.691-.235-2.21-.903l7.363-3.026c2.038-.635 4.033-.798 5.144-.836l4.016-.207c-.07 1.278-.035 2.86.271 4.397l-7.668 1.293a2.444 2.444 0 01-2.217-.77zm14.659-.194L26.224 5.29l-1.28.476c-.205 1.334-.356 3.905.217 6.201.057.226.12.45.19.667.62-.009 1.81-.143 3.357-.658z",
  fill: "currentColor"
})));